// The fulfill flows' shared reads: the inbounds a fulfilment can allocate credit from.
import { baseApi } from './baseApi';
import { handledError } from './listQuery';
import { processLinkableDeclarationsForOrder } from '@/lib/mappers/fulfill';

// Fulfill ▸ Select inbound, from an ORDER. The server derives the material/site match AND the preference ranking from the order itself, so nothing but its id travels.
const LINKABLE_DECLARATIONS_FOR_ORDER_QUERY = `
  query LinkableDeclarationsForOrder($pendingOrderId: ID!, $limit: Int, $page: Int, $filters: DeclarationFilters, $search: DeclarationSearch) {
    linkableDeclarationsForOrder(pendingOrderId: $pendingOrderId, limit: $limit, page: $page, filters: $filters, search: $search) {
      suggestions { ...LinkableRow }
      nodes { ...LinkableRow }
      pageInfo { total page limit hasNextPage hasPreviousPage isEmpty }
    }
  }

  fragment LinkableRow on LinkableOrderDeclaration {
    group
    sustainabilityMismatches { type message attribute }
    declaration {
      id
      referenceId
      declarationNo
      workingUnit
      declarationUnit
      trackingUnit
      adjustedQuantityWorking
      adjustedQuantityDeclaration
      adjustedQuantityTracking
      availableQuantityWorking
      availableQuantityDeclaration
      availableQuantityTracking
      ghgEmissions
      ghgEmissionSavings
      rawMaterialType
      countryOfOrigin
      feedstockCategory
      allocationPreference
      dateOfDispatch
      dateOfDischarge
      discrepancyCount
    }
  }
`;

// `DeclarationSearch` spells the id `referenceId`, as the declarations list does.
const buildLinkableDeclarationSearch = (search) => {
  const term = search?.trim();
  if (!term) return undefined;
  return { referenceId: { contains: term, mode: 'insensitive' } };
};

export const fulfillApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    // Suggestions vs others are ranked server-side, from the order's own preferences.
    getLinkableDeclarationsForOrder: build.query({
      query: ({ pendingOrderId, search, page, limit }) => ({
        document: LINKABLE_DECLARATIONS_FOR_ORDER_QUERY,
        variables: {
          pendingOrderId,
          page,
          limit,
          search: buildLinkableDeclarationSearch(search),
        },
      }),
      transformResponse: (data) =>
        processLinkableDeclarationsForOrder(data.linkableDeclarationsForOrder),
      transformErrorResponse: handledError,
    }),
  }),
});

export const { useGetLinkableDeclarationsForOrderQuery } = fulfillApi;
